// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    min-height: 100vh;
    background:
        radial-gradient(circle at top left, rgba(242, 101, 34, 0.12), transparent 28%),
        radial-gradient(circle at top right, rgba(30, 58, 138, 0.08), transparent 26%),
        linear-gradient(180deg, #fafafa 0%, #f8fafc 42%, #ffffff 100%);
}

.site-shell {
    position: relative;
    overflow: hidden;
}

.site-shell::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image:
        linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),
        linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    pointer-events: none;
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.45), transparent 88%);
}

.hero-surface {
    position: relative;
    background-position: center;
    background-size: cover;
    overflow: hidden;
}

.hero-surface::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.84) 55%, rgba(248, 250, 252, 0.74) 100%);
}

.hero-surface > * {
    position: relative;
    z-index: 1;
}

.section-frame {
    position: relative;
    border: 1px solid rgba(226, 232, 240, 1);
    background: rgba(255, 255, 255, 0.88);
    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.06);
}

.section-frame::before {
    content: "";
    position: absolute;
    left: 24px;
    top: 0;
    height: 3px;
    width: 96px;
    background: linear-gradient(90deg, #f26522 0%, #1e3a8a 100%);
}

.hero-line {
    width: 88px;
    height: 4px;
    background: #f26522;
}

.company-card {
    transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
}

.company-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.09);
    border-color: rgba(148, 163, 184, 0.9);
}

.stagger-in {
    animation: fade-up 0.55s ease both;
}

.stagger-delay-1 {
    animation-delay: 0.08s;
}

.stagger-delay-2 {
    animation-delay: 0.16s;
}

.stagger-delay-3 {
    animation-delay: 0.24s;
}

@keyframes fade-up {
    from {
        opacity: 0;
        transform: translateY(18px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB;;;sEAGkE;AACtE;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;8EAE0E;IAC1E,0BAA0B;IAC1B,oBAAoB;IACpB,yEAAyE;AAC7E;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,gIAAgI;AACpI;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,qCAAqC;IACrC,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,WAAW;IACX,WAAW;IACX,4DAA4D;AAChE;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gFAAgF;AACpF;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":[".App {\n    min-height: 100vh;\n    background:\n        radial-gradient(circle at top left, rgba(242, 101, 34, 0.12), transparent 28%),\n        radial-gradient(circle at top right, rgba(30, 58, 138, 0.08), transparent 26%),\n        linear-gradient(180deg, #fafafa 0%, #f8fafc 42%, #ffffff 100%);\n}\n\n.site-shell {\n    position: relative;\n    overflow: hidden;\n}\n\n.site-shell::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image:\n        linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);\n    background-size: 44px 44px;\n    pointer-events: none;\n    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.45), transparent 88%);\n}\n\n.hero-surface {\n    position: relative;\n    background-position: center;\n    background-size: cover;\n    overflow: hidden;\n}\n\n.hero-surface::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(120deg, rgba(255, 255, 255, 0.97) 0%, rgba(255, 255, 255, 0.84) 55%, rgba(248, 250, 252, 0.74) 100%);\n}\n\n.hero-surface > * {\n    position: relative;\n    z-index: 1;\n}\n\n.section-frame {\n    position: relative;\n    border: 1px solid rgba(226, 232, 240, 1);\n    background: rgba(255, 255, 255, 0.88);\n    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.06);\n}\n\n.section-frame::before {\n    content: \"\";\n    position: absolute;\n    left: 24px;\n    top: 0;\n    height: 3px;\n    width: 96px;\n    background: linear-gradient(90deg, #f26522 0%, #1e3a8a 100%);\n}\n\n.hero-line {\n    width: 88px;\n    height: 4px;\n    background: #f26522;\n}\n\n.company-card {\n    transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;\n}\n\n.company-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.09);\n    border-color: rgba(148, 163, 184, 0.9);\n}\n\n.stagger-in {\n    animation: fade-up 0.55s ease both;\n}\n\n.stagger-delay-1 {\n    animation-delay: 0.08s;\n}\n\n.stagger-delay-2 {\n    animation-delay: 0.16s;\n}\n\n.stagger-delay-3 {\n    animation-delay: 0.24s;\n}\n\n@keyframes fade-up {\n    from {\n        opacity: 0;\n        transform: translateY(18px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
